<template>
  <modal v-model="isVisible" v-if="account !== null">
    <div class="c-modalCard">
      <header class="c-modalCard__header">
        <h4 class="c-modalCard__title">Confirmação de login</h4>
        <a role="button" class="c-modalCard__close" v-on:click="isVisible = false">
          <i class="i-remove"></i>
        </a>
      </header>

      <div class="c-modalCard__body">
        Tem certeza de que deseja logar-se com a conta {{ account.shopName }} ?
      </div>

      <footer class="c-modalCard__footer">
        <button type="button" class="btn"  v-on:click="cancel()">Não</button>
        <button type="button" class="btn btn--success" @click="confirm()">Sim</button>
      </footer>
    </div>
  </modal>
</template>

<script>
  export default {
    data: () => ({
      modal: null,
      isVisible: false
    }),
    props: {
      value: {
        type: Boolean,
        required: true
      },
      account: {
        type: Object,
        required: false
      }
    },
    created () {
      this.isVisible = this.value
    },
    updated () {
      this.modal = document.querySelector('div.c-modal')

      if (this.modal !== null) {
        this.modal.onclick = (event) => {
          if (event.target === this.modal) {
            this.close()
          }
        }
        document.body.onkeyup = (event) => {
          if (event.code === 'Escape') {
            this.close()
          }
        }
      }
    },
    methods: {
      confirm () {
        this.$emit('confirm', true)
        this.close()
      },
      cancel () {
        this.close()
      },
      close (emit) {
        delete document.body.onkeyup
        delete this.modal.onclick

        this.isVisible = false
      }
    },
    watch: {
      isVisible (value) {
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      }
    }
  }
</script>

<style lang="sass" scoped>
  .product-img
    max-width: 75px

    .icon-arrow
      font-size: 25px
      margin: 20px 0
</style>



// WEBPACK FOOTER //
// ModalAccountConfirmation.vue?ca05b622